const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "red",
  "orange",
  "amber",
  "yellow",
  "green",
  "emerald",
  "teal",
  "cyan",
  "blue",
  "indigo",
  "purple",
  "pink",
  "neutral"
] as const

const variant = [
  "solid",
  "outline",
  "soft",
  "subtle"
] as const

const size = [
  "sm",
  "md",
  "lg"
] as const

export default {
  "base": "inline-flex items-center justify-center px-1 rounded-sm font-medium font-sans uppercase",
  "variants": {
    "color": {
      "primary": "",
      "secondary": "",
      "success": "",
      "info": "",
      "warning": "",
      "error": "",
      "red": "",
      "orange": "",
      "amber": "",
      "yellow": "",
      "green": "",
      "emerald": "",
      "teal": "",
      "cyan": "",
      "blue": "",
      "indigo": "",
      "purple": "",
      "pink": "",
      "neutral": ""
    },
    "variant": {
      "solid": "",
      "outline": "",
      "soft": "",
      "subtle": ""
    },
    "size": {
      "sm": "h-4 min-w-[16px] text-[10px]",
      "md": "h-5 min-w-[20px] text-[11px]",
      "lg": "h-6 min-w-[24px] text-[12px]"
    }
  },
  "compoundVariants": [
    {
      "color": "primary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-error"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-red"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-orange"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-amber"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-yellow"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-green"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-emerald"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-teal"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-cyan"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-blue"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-indigo"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-purple"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-pink"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-primary/50 text-primary"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-secondary/50 text-secondary"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-success/50 text-success"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-info/50 text-info"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-warning/50 text-warning"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-error/50 text-error"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-red/50 text-red"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-orange/50 text-orange"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-amber/50 text-amber"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-yellow/50 text-yellow"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-green/50 text-green"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-emerald/50 text-emerald"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-teal/50 text-teal"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-cyan/50 text-cyan"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-blue/50 text-blue"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-indigo/50 text-indigo"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-purple/50 text-purple"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-pink/50 text-pink"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-primary bg-primary/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-secondary bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-success bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-info bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-warning bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-error bg-error/10"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-red bg-red/10"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-orange bg-orange/10"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-amber bg-amber/10"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-yellow bg-yellow/10"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-green bg-green/10"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-emerald bg-emerald/10"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-teal bg-teal/10"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-cyan bg-cyan/10"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-blue bg-blue/10"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-indigo bg-indigo/10"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-purple bg-purple/10"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-pink bg-pink/10"
    },
    {
      "color": "primary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-primary ring ring-inset ring-primary/25 bg-primary/10"
    },
    {
      "color": "secondary" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-secondary ring ring-inset ring-secondary/25 bg-secondary/10"
    },
    {
      "color": "success" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-success ring ring-inset ring-success/25 bg-success/10"
    },
    {
      "color": "info" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-info ring ring-inset ring-info/25 bg-info/10"
    },
    {
      "color": "warning" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-warning ring ring-inset ring-warning/25 bg-warning/10"
    },
    {
      "color": "error" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-error ring ring-inset ring-error/25 bg-error/10"
    },
    {
      "color": "red" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-red ring ring-inset ring-red/25 bg-red/10"
    },
    {
      "color": "orange" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-orange ring ring-inset ring-orange/25 bg-orange/10"
    },
    {
      "color": "amber" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-amber ring ring-inset ring-amber/25 bg-amber/10"
    },
    {
      "color": "yellow" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-yellow ring ring-inset ring-yellow/25 bg-yellow/10"
    },
    {
      "color": "green" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-green ring ring-inset ring-green/25 bg-green/10"
    },
    {
      "color": "emerald" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-emerald ring ring-inset ring-emerald/25 bg-emerald/10"
    },
    {
      "color": "teal" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-teal ring ring-inset ring-teal/25 bg-teal/10"
    },
    {
      "color": "cyan" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-cyan ring ring-inset ring-cyan/25 bg-cyan/10"
    },
    {
      "color": "blue" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-blue ring ring-inset ring-blue/25 bg-blue/10"
    },
    {
      "color": "indigo" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-indigo ring ring-inset ring-indigo/25 bg-indigo/10"
    },
    {
      "color": "purple" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-purple ring ring-inset ring-purple/25 bg-purple/10"
    },
    {
      "color": "pink" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "text-pink ring ring-inset ring-pink/25 bg-pink/10"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "solid" as typeof variant[number],
      "class": "text-inverted bg-inverted"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "outline" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-default"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "soft" as typeof variant[number],
      "class": "text-default bg-elevated"
    },
    {
      "color": "neutral" as typeof color[number],
      "variant": "subtle" as typeof variant[number],
      "class": "ring ring-inset ring-accented text-default bg-elevated"
    }
  ],
  "defaultVariants": {
    "variant": "outline" as typeof variant[number],
    "color": "neutral" as typeof color[number],
    "size": "md" as typeof size[number]
  }
}